import { visserApi } from './visserApi';
const sendEmailWithAttachment = async (purchaseInvoiceAttachment) => {
    const response = await visserApi.post(`common/SendEmailWithAttachment`, purchaseInvoiceAttachment);
    return response.data;
};
const getEmailTemplateByName = async (name) => {
    return await visserApi.get(`common/GetEmailTemplateByName/${name}`);
};
const getRecordNumberById = async (requet) => {
    const response = await visserApi.post(`common/GetRecordNumberById`, requet);
    return response.data;
};
const CommonApi = {
    sendEmailWithAttachment,
    getEmailTemplateByName,
    getRecordNumberById
};
export default CommonApi;
